import { render } from "./WeaponCompendiumModal.vue?vue&type=template&id=34ad07da"
import script from "./WeaponCompendiumModal.vue?vue&type=script&lang=js"
export * from "./WeaponCompendiumModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__